export default [
  {
    path: '/active-gradereport-free/index',
    name: 'index',
    component: () => import('@/views/active-gradereport-free/index'),
    meta: {
      title: '高考预测报告'
    }
  },
  {
    path: '/active-gradereport-free/my-list',
    name: 'my-list',
    component: () => import('@/views/active-gradereport-free/my-list'),
    meta: {
      title: '高考预测报告'
    }
  },{
    path: '/active-gradereport-free/buy-record',
    name: 'buy-record',
    component: () => import('@/views/active-gradereport-free/buy-record'),
    meta: {
      title: '购买记录'
    }
  },{
    path: '/active-gradereport-free/about-our',
    name: 'about-our',
    component: () => import('@/views/active-gradereport-free/about-our'),
    meta: {
      title: '关于我们'
    }
  },{
    path: '/active-gradereport-free/msg-input',
    name: 'msg-input',
    component: () => import('@/views/active-gradereport-free/msg-input'),
    meta: {
      title: '信息填写'
    }
  },{
    path: '/active-gradereport-free/first-msg',
    name: 'first-msg',
    component: () => import('@/views/active-gradereport-free/first-msg'),
    meta: {
      title: '信息填写'
    }
  },{
    path: '/active-gradereport-free/grade-report',
    name: 'grade-report',
    component: () => import('@/views/active-gradereport-free/grade-report'),
    meta: {
      title: '高考预测报告'
    }
  },{
    path: '/active-gradereport-free/pay',
    name: 'pay',
    component: () => import('@/views/active-gradereport-free/pay'),
    meta: {
      title: '支付'
    }
  },{
    path: '/active-gradereport-free/payInfo',
    name: 'payInfo',
    component: () => import('@/views/active-gradereport-free/payInfo'),
    meta: {
      title: '支付详情'
    }
  },{
    path: '/active-gradereport-free/batch',
    name: 'batch',
    component: () => import('@/views/active-gradereport-free/batch'),
    meta: {
      title: '查批次'
    }
  },{
    path: '/active-gradereport-free/oneline',
    name: 'oneline',
    component: () => import('@/views/active-gradereport-free/oneline'),
    meta: {
      title: '一分一段'
    }
  },{
    path: '/active-gradereport-free/agreement',
    name: 'agreement',
    component: () => import('@/views/active-gradereport-free/agreement'),
    meta: {
      title: '协议内容'
    }
  },{
    path: '/active-gradereport-free/paySuccess',
    name: 'paySuccess',
    component: () => import('@/views/active-gradereport-free/paySuccess'),
    meta: {
      title: '高考预测报告'
    }
  },
  {
    path: '/active-gradereport-free/transit',
    name: 'transit',
    component: () => import('@/views/active-gradereport-free/transit'),
    meta: {
      title: '高考预测报告'
    }
  },
  {
    path: '/active-gradereport-free/home',
    name: 'home',
    component: () => import('@/views/active-gradereport-free/home'),
    meta: {
      title: '高考预测报告'
    }
  },
  {
    path: '/active-gradereport-free/record',
    name: 'record',
    component: () => import('@/views/active-gradereport-free/record'),
    meta: {
      title: '高考预测报告'
    }
  },
  {
    path: '/active-gradereport-free/introduction',
    name: 'introduction',
    component: () => import('@/views/active-gradereport-free/introduction'),
    meta: {
      title: '高考预测报告'
    }
  },
  {
    path: '/active-gradereport-free/cdkey',
    name: 'cdkey',
    component: () => import('@/views/active-gradereport-free/cdkey'),
    meta: {
      title: '高考预测报告'
    }
  },
  {
    path: '/active-gradereport-free/invite',
    name: 'invite',
    component: () => import('@/views/active-gradereport-free/invite'),
    meta: {
      title: '高考预测报告'
    }
  },
]
